export default "__VITE_ASSET__f6e91fbb__"